module.exports = __webpack_public_path__ + "static/media/icon-change-password.f03fed61.svg";